<script lang="ts" setup>
import {PhHouse} from "@phosphor-icons/vue";
import type {
  FocalPointAsset,
  FromResolver,
} from "#magnolia-layer/types/magnolia-types";

const props = defineProps<{
  title?: string;
  text?: string;
  image?: FromResolver<FocalPointAsset>;
  stripePosition?: "none" | "left" | "right";
}>();

const spineTitleState = useState("spineTitle");
const propAbstract = inject<string | undefined>("abstract");
const overlayClass =
  props.stripePosition && props.stripePosition !== "none"
    ? `has-logo-overlay-${props.stripePosition}`
    : "";

const headerTitle = props.title ?? spineTitleState.value; // make sure the get the value to not make it reactive
</script>

<template>
  <div class="col-span-full bg-black">
    <MagnoliaPicture
      :modifiers="{grayscale: 1}"
      class="max-h-[75vh] picture-cover"
      :class="overlayClass"
      sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
      :asset="image"
      v-if="image">
    </MagnoliaPicture>
  </div>
  <div class="inner-content-grid">
    <Breadcrumb></Breadcrumb>
    <h1 class="text-7xl mt-7 mb-16">{{ headerTitle }}</h1>
  </div>

  <div v-if="propAbstract || text" class="inner-content-grid">
    <template v-if="text">
      <div class="text-xl lg:text-3xl mb-4" v-html="text"></div>
    </template>
    <p v-else class="text-xl lg:text-3xl mb-4">{{ propAbstract }}</p>
  </div>
</template>

<style lang="scss" scoped></style>
